// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.image-popup-modal .modal-content {
    width: 100%;
    height: auto;
    background: transparent;
    border-radius: 0px;
    border: none;
}

/* .modal-backdrop.show {
    z-index: 999999;
} */

.image-popup img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 13px;
}

.image-popup {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    margin: 0 auto;
    gap: 6px;
    height: auto;
}


.image-popup button {
    height: 50px;
    font-size: 60px;
    background: no-repeat;
    border: none;
    outline: none;
    margin-left: 20px;
    margin-right: 20px;
    color: #00A19B;
}

.img-modal-cross-btn button {
    border: none;
    background: no-repeat;
    font-size: 20px;
    color: red;
    cursor: pointer;
    position: absolute;
    right: 60px;
    top: 26px;
    background: #fff;
    border-radius: 50%;
    width: 36px;
    height: 36px;
}

.imagegalery-modal-cross-btn button{
    background: #f3f3f3;
}

.custom-backdrop {
    -webkit-backdrop-filter: blur(80px);
            backdrop-filter: blur(80px); /* Adjust the blur amount as needed */
    background: #fff !important;
    --bs-backdrop-opacity: 1 !important;
  }

.popup-previous-arrow img {
    width: 40px;
    cursor: pointer;
}


.popup-previous-arrow img:hover{
    scale: 0.9;
}

.imagegalery-modal-cross-btn button:hover{
    scale: 0.9;
}


.image-popup {
    width: 100%;
}


@media(max-width: 1024px){
    .image-popup {
        width: 400px;
    }

    .image-popup img {
        width: 80%;
        object-fit: cover;
        border-radius: 13px;
    }

    .popup-previous-arrow img {
        width: 40px;
    }
}


@media(max-width: 400px){
.image-popup {
    width: 280px;
}


}


@media(max-width: 360px){
    .image-popup {
        width: 260px;
    }

    .image-popup img {
        width: 96%;
        object-fit: cover;
        border-radius: 13px;
    }

    .popup-previous-arrow img {
        width: 30px;
    }

    .img-modal-cross-btn button {
        font-size: 14px;
        width: 28px;
        height: 28px;
    }

    .upload-image-button label h4 {
        font-size: 12px;
    }

    .upload-image-button img {
        width: 40px;
    }

    .before-footer-main-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
    }

    .upload-image-button {
        display: flex;
        height: 56px;
    }
}

@media(max-width: 330px){
    .image-popup {
        width: 220px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/Transaction/ImageGallery.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAA2B;YAA3B,2BAA2B,EAAE,qCAAqC;IAClE,2BAA2B;IAC3B,mCAAmC;EACrC;;AAEF;IACI,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;AACJ;;;AAGA;AACA;IACI,YAAY;AAChB;;;AAGA;;;AAGA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["\n.image-popup-modal .modal-content {\n    width: 100%;\n    height: auto;\n    background: transparent;\n    border-radius: 0px;\n    border: none;\n}\n\n/* .modal-backdrop.show {\n    z-index: 999999;\n} */\n\n.image-popup img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 13px;\n}\n\n.image-popup {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 300px;\n    margin: 0 auto;\n    gap: 6px;\n    height: auto;\n}\n\n\n.image-popup button {\n    height: 50px;\n    font-size: 60px;\n    background: no-repeat;\n    border: none;\n    outline: none;\n    margin-left: 20px;\n    margin-right: 20px;\n    color: #00A19B;\n}\n\n.img-modal-cross-btn button {\n    border: none;\n    background: no-repeat;\n    font-size: 20px;\n    color: red;\n    cursor: pointer;\n    position: absolute;\n    right: 60px;\n    top: 26px;\n    background: #fff;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n}\n\n.imagegalery-modal-cross-btn button{\n    background: #f3f3f3;\n}\n\n.custom-backdrop {\n    backdrop-filter: blur(80px); /* Adjust the blur amount as needed */\n    background: #fff !important;\n    --bs-backdrop-opacity: 1 !important;\n  }\n\n.popup-previous-arrow img {\n    width: 40px;\n    cursor: pointer;\n}\n\n\n.popup-previous-arrow img:hover{\n    scale: 0.9;\n}\n\n.imagegalery-modal-cross-btn button:hover{\n    scale: 0.9;\n}\n\n\n.image-popup {\n    width: 100%;\n}\n\n\n@media(max-width: 1024px){\n    .image-popup {\n        width: 400px;\n    }\n\n    .image-popup img {\n        width: 80%;\n        object-fit: cover;\n        border-radius: 13px;\n    }\n\n    .popup-previous-arrow img {\n        width: 40px;\n    }\n}\n\n\n@media(max-width: 400px){\n.image-popup {\n    width: 280px;\n}\n\n\n}\n\n\n@media(max-width: 360px){\n    .image-popup {\n        width: 260px;\n    }\n\n    .image-popup img {\n        width: 96%;\n        object-fit: cover;\n        border-radius: 13px;\n    }\n\n    .popup-previous-arrow img {\n        width: 30px;\n    }\n\n    .img-modal-cross-btn button {\n        font-size: 14px;\n        width: 28px;\n        height: 28px;\n    }\n\n    .upload-image-button label h4 {\n        font-size: 12px;\n    }\n\n    .upload-image-button img {\n        width: 40px;\n    }\n\n    .before-footer-main-wrap {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 8px;\n    }\n\n    .upload-image-button {\n        display: flex;\n        height: 56px;\n    }\n}\n\n@media(max-width: 330px){\n    .image-popup {\n        width: 220px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
